"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.IntelligentCopyComponent = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseDatetimePicker = require("nicbase-datetime-picker");

var _nicbaseDialogs = require("nicbase-dialogs");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _uuid = require("uuid");

var _constants = require("../constants");

var _intelligentCopyComponentModule = _interopRequireDefault(require("./intelligent-copy-component.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// function that adds the year, month and day from the given baseDate to a tour date
var getDateWithTourStartTime = function getDateWithTourStartTime(tour, baseDate) {
  if (baseDate === null) return null;
  var startTime = tour.scheduledStartTime;

  if (!startTime) {
    var startWaypoint = tour.wayPoints.find(function (wayPoint) {
      return wayPoint.type === _constants.WAYPOINT_TYPES.START;
    });
    startTime = startWaypoint && startWaypoint.plannedStartTime;
  }

  if (!startTime) {
    var _startWaypoint = tour.wayPoints.find(function (wayPoint) {
      return wayPoint.scheduledTimeOfArrival;
    });

    startTime = _startWaypoint && _startWaypoint.scheduledTimeOfArrival;
  }

  var calculatedTimestamp = new Date(startTime);
  calculatedTimestamp.setFullYear(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate());
  return calculatedTimestamp;
};

var getEarliestPossibleStart = function getEarliestPossibleStart(tour) {
  var calculatedStartDate = getDateWithTourStartTime(tour, new Date(Date.now())); // is the calculated start date later than the time now?

  if (calculatedStartDate.getTime() - new Date().getTime() > 0) {
    return calculatedStartDate;
  } // if not, use this time tomorrow


  calculatedStartDate.setUTCHours(calculatedStartDate.getUTCHours() + 24);
  return calculatedStartDate;
};

var IntelligentCopyComponent = function IntelligentCopyComponent(_ref) {
  var _tour$route, _useState9;

  var tour = _ref.tour,
      isActive = _ref.isActive,
      onSave = _ref.onSave,
      onCancel = _ref.onCancel;

  var _useUser = (0, _nicbaseReducers.useUser)(),
      locale = _useUser.locale,
      timezone = _useUser.timezone;

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var intl = (0, _nicbaseTranslation.useIntl)();
  var minDate = (0, _react.useMemo)(function () {
    return getEarliestPossibleStart(tour);
  }, [tour]);
  var maxDate = (0, _react.useMemo)(function () {
    return new Date(new Date(minDate).setUTCMonth(new Date(minDate).getUTCMonth() + 1));
  }, [minDate]);

  var _useState = (0, _react.useState)(!((_tour$route = tour.route) !== null && _tour$route !== void 0 && _tour$route.id)),
      _useState2 = _slicedToArray(_useState, 2),
      isFormValid = _useState2[0],
      setIsFormValid = _useState2[1];

  var _useState3 = (0, _react.useState)(getDateWithTourStartTime(tour, new Date(new Date(minDate).setUTCDate(new Date(minDate).getUTCDate() + 1)))),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedDate = _useState4[0],
      setSelectedDate = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      seriesCopy = _useState6[0],
      setSeriesCopy = _useState6[1];

  var _useState7 = (0, _react.useState)((_useState9 = {}, _defineProperty(_useState9, _constants.DAYS.MONDAY, false), _defineProperty(_useState9, _constants.DAYS.TUESDAY, false), _defineProperty(_useState9, _constants.DAYS.WEDNESDAY, false), _defineProperty(_useState9, _constants.DAYS.THURSDAY, false), _defineProperty(_useState9, _constants.DAYS.FRIDAY, false), _defineProperty(_useState9, _constants.DAYS.SATURDAY, false), _defineProperty(_useState9, _constants.DAYS.SUNDAY, false), _useState9)),
      _useState8 = _slicedToArray(_useState7, 2),
      seriesDays = _useState8[0],
      setSeriesDays = _useState8[1];

  var tourRoute = tour.route,
      _tour$wayPoints = tour.wayPoints,
      wayPoints = _tour$wayPoints === void 0 ? [] : _tour$wayPoints,
      _tour$segments = tour.segments,
      segments = _tour$segments === void 0 ? [] : _tour$segments; // request to find route

  var _usePortalFindRoute = (0, _hooks.usePortalFindRoute)({
    portalId: portalId,
    routeId: tourRoute === null || tourRoute === void 0 ? void 0 : tourRoute.id,
    options: {
      enabled: Boolean(tourRoute === null || tourRoute === void 0 ? void 0 : tourRoute.id)
    }
  }),
      routeData = _usePortalFindRoute.data,
      isLoadingRouteData = _usePortalFindRoute.isLoading; // request to save the route


  var _usePortalSaveRoute = (0, _hooks.usePortalSaveRoute)({
    portalId: portalId
  }),
      saveRouteRequest = _usePortalSaveRoute.mutate;

  var onSeriesCopyChanged = function onSeriesCopyChanged() {
    setSeriesCopy(function (prev) {
      return !prev;
    });
  };

  var onSeriesDayToggled = function onSeriesDayToggled(toggledDay) {
    setSeriesDays(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, toggledDay, !prev[toggledDay]));
    });
  };

  var getNumberOfToursToCopy = (0, _react.useCallback)(function () {
    var numTours = 0;
    var nextDateToCopy = new Date(minDate); // loop through all the days between today and the series end date, and copy the tours on the selected days

    while (nextDateToCopy < selectedDate) {
      // tour date
      var tourDate = getDateWithTourStartTime(tour, nextDateToCopy);
      nextDateToCopy.setDate(nextDateToCopy.getDate() + 1);

      if (seriesDays[tourDate.getDay()]) {
        numTours += 1;
      }
    }

    return numTours;
  }, [minDate, selectedDate, seriesDays, tour]);

  var copyTour = function copyTour(tourDate) {
    var earliestStartTime = null;
    var scheduledStartTime = null;
    var scheduledEndTime = null;
    var delayedStartLimitAlarm = null;
    var delayedEndLimitAlarm = null; // if the tour is time based, use the scheduledStartTime

    var startTime = tour.scheduledStartTime;
    var differenceInMilliseconds = null; // if the tour has a START poi, use its planned start time

    if (!startTime) {
      var _startWaypoint2 = wayPoints.find(function (wayPoint) {
        return wayPoint.type === _constants.WAYPOINT_TYPES.START;
      });

      startTime = _startWaypoint2 && _startWaypoint2.plannedStartTime;
    } //  otherwise use the scheduledTimeOfArrival from the first POI that has a scheduledTimeOfArrival


    if (!startTime) {
      var _startWaypoint3 = wayPoints.find(function (wayPoint) {
        return wayPoint.scheduledTimeOfArrival;
      });

      startTime = _startWaypoint3 && _startWaypoint3.scheduledTimeOfArrival;
    } // If there is a start poi, set the earliestStartTime to the selected date for the tour


    var startWaypoint = wayPoints.find(function (wayPoint) {
      return wayPoint.type === _constants.WAYPOINT_TYPES.START;
    });

    if (startWaypoint) {
      var earliestStartTimeObject = new Date(tourDate);

      if (tour.earliestStartTime) {
        // if the tour to copy already has an earliest start date, use the hours minutes and seconds from it.
        var existingEarliestStartTime = new Date(tour.earliestStartTime);
        earliestStartTimeObject.setHours(existingEarliestStartTime.getHours());
        earliestStartTimeObject.setMinutes(existingEarliestStartTime.getMinutes());
        earliestStartTimeObject.setSeconds(existingEarliestStartTime.getSeconds());
        earliestStartTimeObject.setMilliseconds(existingEarliestStartTime.getMilliseconds());
      } else {
        // set earliestStartTime to the selected tag at 00:00 (in the user time zone)
        earliestStartTimeObject.setHours(0);
        earliestStartTimeObject.setMinutes(0);
        earliestStartTimeObject.setSeconds(0);
        earliestStartTimeObject.setMilliseconds(0);
      }

      earliestStartTime = earliestStartTimeObject.toISOString();
    }

    if (startTime) {
      differenceInMilliseconds = new Date(tourDate) - new Date(startTime);

      if (tour.earliestStartTime && !earliestStartTime) {
        var dateObject = new Date(tour.earliestStartTime);
        var hours = dateObject.getHours();
        var minutes = dateObject.getMinutes();
        dateObject.setMilliseconds(differenceInMilliseconds + dateObject.getMilliseconds());
        dateObject.setHours(hours);
        dateObject.setMinutes(minutes);
        earliestStartTime = dateObject.toISOString();
      }

      if (tour.scheduledStartTime) {
        var _dateObject = new Date(tour.scheduledStartTime);

        var _hours = _dateObject.getHours();

        var _minutes = _dateObject.getMinutes();

        _dateObject.setMilliseconds(differenceInMilliseconds + _dateObject.getMilliseconds());

        _dateObject.setHours(_hours);

        _dateObject.setMinutes(_minutes);

        scheduledStartTime = _dateObject.toISOString();
      }

      if (tour.scheduledEndTime) {
        var _dateObject2 = new Date(tour.scheduledEndTime);

        var _hours2 = _dateObject2.getHours();

        var _minutes2 = _dateObject2.getMinutes();

        _dateObject2.setMilliseconds(differenceInMilliseconds + _dateObject2.getMilliseconds());

        _dateObject2.setHours(_hours2);

        _dateObject2.setMinutes(_minutes2);

        scheduledEndTime = _dateObject2.toISOString();
      }

      if (tour.delayedStartLimitAlarm) {
        var _dateObject3 = new Date(tour.delayedStartLimitAlarm);

        var _hours3 = _dateObject3.getHours();

        var _minutes3 = _dateObject3.getMinutes();

        _dateObject3.setMilliseconds(differenceInMilliseconds + _dateObject3.getMilliseconds());

        _dateObject3.setHours(_hours3);

        _dateObject3.setMinutes(_minutes3);

        delayedStartLimitAlarm = _dateObject3.toISOString();
      }

      if (tour.delayedEndLimitAlarm) {
        var _dateObject4 = new Date(tour.delayedEndLimitAlarm);

        var _hours4 = _dateObject4.getHours();

        var _minutes4 = _dateObject4.getMinutes();

        _dateObject4.setMilliseconds(differenceInMilliseconds + _dateObject4.getMilliseconds());

        _dateObject4.setHours(_hours4);

        _dateObject4.setMinutes(_minutes4);

        delayedEndLimitAlarm = _dateObject4.toISOString();
      }
    }

    var newTourRoute = null; // if there is a route, generate a new id and save the route under the new id

    if (tourRoute !== null && tourRoute !== void 0 && tourRoute.id) {
      var newId = (0, _uuid.v4)();
      newTourRoute = _objectSpread(_objectSpread({}, tourRoute), {}, {
        id: newId
      }); // save the route under the new id

      saveRouteRequest(_objectSpread(_objectSpread({}, routeData), {}, {
        id: newId
      }));
    }

    var copiedTour = _objectSpread(_objectSpread({}, tour), {}, {
      route: newTourRoute,
      assetId: null,
      segments: segments,
      assetType: null,
      dataRequest: null,
      earliestStartTime: earliestStartTime,
      scheduledStartTime: scheduledStartTime,
      delayedStartLimitAlarm: delayedStartLimitAlarm,
      delayedEndLimitAlarm: delayedEndLimitAlarm,
      scheduledEndTime: scheduledEndTime,
      sharedWithPortals: null,
      id: null,
      status: null,
      token: null,
      timeOfLastBoxDataMessage: null,
      lastBoxDataStatus: null,
      triggeredAlarms: null,
      startBy: null,
      stopBy: null,
      generatedAlarmIds: null,
      mileageCalculations: null,
      mileage: null,
      gpsMileage: null,
      wayPoints: tour.wayPoints.map(function (wayPoint) {
        var plannedStartTime = wayPoint.plannedStartTime,
            scheduledTimeOfArrival = wayPoint.scheduledTimeOfArrival;

        if (startTime && plannedStartTime !== null) {
          var _dateObject5 = new Date(plannedStartTime);

          var _hours5 = _dateObject5.getHours();

          var _minutes5 = _dateObject5.getMinutes();

          _dateObject5.setMilliseconds(differenceInMilliseconds + _dateObject5.getMilliseconds());

          _dateObject5.setHours(_hours5);

          _dateObject5.setMinutes(_minutes5);

          plannedStartTime = _dateObject5.toISOString();
        }

        if (startTime && scheduledTimeOfArrival !== null) {
          var _dateObject6 = new Date(scheduledTimeOfArrival);

          var _hours6 = _dateObject6.getHours();

          var _minutes6 = _dateObject6.getMinutes();

          _dateObject6.setMilliseconds(differenceInMilliseconds + _dateObject6.getMilliseconds());

          _dateObject6.setHours(_hours6);

          _dateObject6.setMinutes(_minutes6);

          scheduledTimeOfArrival = _dateObject6.toISOString();
        }

        return Object.assign({}, wayPoint, {
          realTimeOfArrival: null,
          realTimeOfDeparture: null,
          estimatedTimeOfArrival: null,
          plannedStartTime: plannedStartTime,
          scheduledTimeOfArrival: scheduledTimeOfArrival,
          id: null
        });
      })
    });

    onSave(copiedTour);
  };

  var copyTourSeries = function copyTourSeries() {
    var nextDateToCopy = new Date(minDate); // loop through all the days between today and the series end date, and copy the tours on the selected days

    while (nextDateToCopy < selectedDate) {
      // tour date
      var tourDate = getDateWithTourStartTime(tour, nextDateToCopy);
      nextDateToCopy.setDate(nextDateToCopy.getDate() + 1);

      if (seriesDays[tourDate.getDay()]) {
        copyTour(tourDate);
      }
    }
  };

  var copyTourOneOff = function copyTourOneOff() {
    copyTour(selectedDate);
  };

  var onCopyTourClicked = function onCopyTourClicked() {
    if (seriesCopy) {
      copyTourSeries();
    } else {
      copyTourOneOff();
    }
  };

  var handleSelectedDateChanged = function handleSelectedDateChanged(newDate) {
    setSelectedDate(getDateWithTourStartTime(tour, newDate));
  }; // validate form if inputs or route data have changed


  (0, _react.useEffect)(function () {
    var _routeData$geometry, _routeData$geometry$c;

    var numberOfToursToCopy = getNumberOfToursToCopy(); // if no date selected make form invalid

    var dateSelected = selectedDate !== null; // if series copy, at least one day must be selected

    var validOptionsSelected = !seriesCopy || numberOfToursToCopy > 0; // only allow copy if there is the route is already downloaded, or there is no route

    var readyToCopy = !(tourRoute !== null && tourRoute !== void 0 && tourRoute.id) || (routeData === null || routeData === void 0 ? void 0 : (_routeData$geometry = routeData.geometry) === null || _routeData$geometry === void 0 ? void 0 : (_routeData$geometry$c = _routeData$geometry.coordinates) === null || _routeData$geometry$c === void 0 ? void 0 : _routeData$geometry$c.length) > 0;
    setIsFormValid(readyToCopy && validOptionsSelected && dateSelected);
  }, [routeData, seriesCopy, selectedDate, getNumberOfToursToCopy, tourRoute]);
  return /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog, {
    active: isActive
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog.Header, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.copyTour"
    })
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog.Body, null, isLoadingRouteData ? /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicbaseSpinnerComponent, null) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col justify-center text-left p-24"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.oneTime"
  }, function (text) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])({
        'font-normal': seriesCopy,
        'font-bold': !seriesCopy
      })
    }, text);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Switch, {
    className: _intelligentCopyComponentModule["default"]["switch"],
    checked: seriesCopy,
    onChange: onSeriesCopyChanged,
    theme: {
      off: 'toggle-off',
      on: 'toggle-on'
    }
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.series"
  }, function (text) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])({
        'font-normal': !seriesCopy,
        'font-bold': seriesCopy
      })
    }, text);
  })), seriesCopy ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-96 mt-4"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
    onChange: function onChange() {
      return onSeriesDayToggled(_constants.DAYS.MONDAY);
    },
    checked: seriesDays[_constants.DAYS.MONDAY],
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.monday",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
    onChange: function onChange() {
      return onSeriesDayToggled(_constants.DAYS.TUESDAY);
    },
    checked: seriesDays[_constants.DAYS.TUESDAY],
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.tuesday",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
    onChange: function onChange() {
      return onSeriesDayToggled(_constants.DAYS.WEDNESDAY);
    },
    checked: seriesDays[_constants.DAYS.WEDNESDAY],
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.wednesday",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
    onChange: function onChange() {
      return onSeriesDayToggled(_constants.DAYS.THURSDAY);
    },
    checked: seriesDays[_constants.DAYS.THURSDAY],
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.thursday",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
    onChange: function onChange() {
      return onSeriesDayToggled(_constants.DAYS.FRIDAY);
    },
    checked: seriesDays[_constants.DAYS.FRIDAY],
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.friday",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
    onChange: function onChange() {
      return onSeriesDayToggled(_constants.DAYS.SATURDAY);
    },
    checked: seriesDays[_constants.DAYS.SATURDAY],
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.saturday",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
    onChange: function onChange() {
      return onSeriesDayToggled(_constants.DAYS.SUNDAY);
    },
    checked: seriesDays[_constants.DAYS.SUNDAY],
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.sunday",
      tagName: "span"
    })
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.copyTourSeriesMessage"
  }, function (text) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-gray-500 mt-4"
    }, text);
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mt-4"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Calendar, {
    className: "mr-2 inline-block fill-blue-500"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseDatetimePicker.DatePicker, {
    inputLabel: intl.formatMessage({
      id: 'widgets.tourBoard.endOfSeries'
    }),
    selectedDate: selectedDate,
    locale: locale,
    timezone: timezone,
    minDate: minDate,
    maxDate: maxDate,
    enableTime: false,
    onChange: handleSelectedDateChanged
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.endOfSeriesMessage"
  }, function (text) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-gray-500 mt-4"
    }, text);
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-96 mt-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Calendar, {
    className: "mr-2 inline-block fill-blue-500"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseDatetimePicker.DatePicker, {
    inputLabel: intl.formatMessage({
      id: 'widgets.tourBoard.tourstart.datetime'
    }),
    selectedDate: selectedDate,
    locale: locale,
    timezone: timezone,
    minDate: minDate,
    maxDate: maxDate,
    enableTime: false,
    onChange: handleSelectedDateChanged
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.copyTourOneOffMessage"
  }, function (text) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-gray-500 mt-4"
    }, text);
  })))), /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog.Footer, {
    className: "gap-2"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    primary: true,
    onClick: onCancel
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "common.cancel",
    tagName: "span"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    primary: true,
    raised: true,
    disabled: isLoadingRouteData || !isFormValid,
    onClick: function onClick() {
      return onCopyTourClicked();
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.createTour",
    tagName: "span"
  }))));
};

exports.IntelligentCopyComponent = IntelligentCopyComponent;

var noop = function noop() {};

IntelligentCopyComponent.propTypes = {
  isActive: _propTypes["default"].bool,
  onSave: _propTypes["default"].func,
  onCancel: _propTypes["default"].func,
  tour: _propTypes["default"].shape({
    earliestStartTime: _propTypes["default"].string,
    scheduledStartTime: _propTypes["default"].string,
    scheduledEndTime: _propTypes["default"].string,
    delayedStartLimitAlarm: _propTypes["default"].string,
    delayedEndLimitAlarm: _propTypes["default"].string,
    route: _propTypes["default"].shape({
      id: _propTypes["default"].string
    }),
    wayPoints: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
    segments: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  }).isRequired
};
IntelligentCopyComponent.defaultProps = {
  isActive: false,
  onSave: noop,
  onCancel: noop
};
var _default = IntelligentCopyComponent;
exports["default"] = _default;